import { EMPTY_AUDIT_TRAIL_REPORT_MODEL } from "presentation/model/AuditTrailReport/AuditTrailReportModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: AuditTrailReportProvider,
    useTracked: useAuditTrailReportTracked
} = createContainer(() => useState(EMPTY_AUDIT_TRAIL_REPORT_MODEL), {concurrentMode: true});
export { AuditTrailReportProvider, useAuditTrailReportTracked };
